import { useContext } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Modal, ModalContext, Text } from 'dash-ui';

import {
  GetCmsUsersDocument,
  useArchiveCmsUserMutation,
} from 'gql/generated.graphql';

function ArchiveUserModal() {
  const { t: tManagementPage } = useTranslation('pages', {
    keyPrefix: 'managementPage',
  });
  const { t: tLabels } = useTranslation('common', {
    keyPrefix: 'labels',
  });

  const { isOpenCurrent, toggleModal, payload, setPayload } =
    useContext(ModalContext);
  const isOpen = isOpenCurrent['ArchiveUserModal'];

  const [archiveCMSUserById, { loading }] = useArchiveCmsUserMutation({
    refetchQueries: [GetCmsUsersDocument],
  });

  function closeModal() {
    setPayload(null);
    toggleModal(false, 'ArchiveUserModal');
  }

  function submitCMSUserArchive() {
    archiveCMSUserById({ variables: { cmsUserAccountId: payload?.userId, archive: payload?.archive } })
      .then(() => {
        toast.success(payload?.archive ? tManagementPage('toasts.userArchived') : tManagementPage('toasts.userUnarchived'));
        closeModal();
      })
      .catch((error: any) => {
        toast.error(error.message);
        closeModal();
      });
  }

  return (
    <Modal
      isOpen={isOpen}
      title={payload?.archive ? tManagementPage`archiveConfirmationTitle` || '' : tManagementPage`unarchiveConfirmationTitle` || ''}
      onRequestClose={closeModal}
      cancelButton={{
        title: payload?.archive ? tLabels`archive` : tLabels`unarchive`,
        onClick: submitCMSUserArchive,
        colorVariation: payload?.archive ? 'danger' : 'default',
        isLoading: loading,
        w: '100%',
        variation: 'primary',
      }}
      submitButton={{
        title: tLabels`cancel`,
        onClick: closeModal,
        w: '100%',
        variation: 'outline',
      }}
    >
      <Text>{payload?.archive ? tManagementPage`archiveConfirmationBody` || '' : tManagementPage`unarchiveConfirmationBody` || ''}</Text>
    </Modal>
  );
}

export default ArchiveUserModal;
